<template>
    <div class="contract-manage-iflow-table">
        <table-box v-loading="subTabTable.tableLoading" :selection="TABLECONFIG.selection" ref="biddingAccountRef"
            :columns="TABLECONFIG.columns" :height="tableHeight" :actions="TABLECONFIG.actions"
            :rows="subTabTable.totalData" @action-click="actionClick">
            <template #col-append="{ col, row, rIndex }">
                <a v-if="col.prop === 'websiteUrl'" :href="row.websiteUrl" target="_blank"
                    class="customer-mip-page-link no-wrap">{{ row.websiteUrl }}</a>
                <span v-else-if="col.prop === 'websiteAccount'" :title="row.websiteAccount">{{
                    maskAccount(row.websiteAccount) }}</span>
                <span v-else-if="col.prop === 'accountPassword'">********</span>
                <span v-else-if="col.prop === 'registrantPhone'" :title="row.registrantPhone">{{
                    desensitization.phone(row.registrantPhone) }}</span>
            </template>
        </table-box>
        <div class="footer">
            <lots-pagination @size-change='subTabTable.sizeChange' :current-page.sync='subTabTable.pageNo'
                @current-change='subTabTable.pageChange' size="small" layout='total, sizes, prev, pager, next, jumper'
                :total='subTabTable.pageTotal' />
        </div>
    </div>
</template>

<script>
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getBiddingAccountList } from '@mdm/api/customer/biddingAccountManage.js';
import { watch, computed, reactive, toRefs } from '@vue/composition-api';
import { tableConfig } from './config.js';
import tableBox from '@/components/lots/tableBox/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
export default {
    components: {
        lotsPagination, tableBox
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        },
        tableHeight: {
            type: Number,
            default: 357
        },
        actions: {
            type: Object,
            default() {
                return {
                    list: []
                };
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        const TABLECONFIG = computed(() => {
            return config;
        });
        const convertEmptyStringsToNull = (obj) => {
            return Object.fromEntries(
                Object.entries(obj).map(([key, value]) => {
                    if (typeof value === 'string') {
                        return [key, value.trim() === '' ? null : value];
                    }
                    return [key, value];
                })
            );
        };
        class BiddingAccountTableClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerCode = props.detailData.customerCode;
                condition = convertEmptyStringsToNull(condition);
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    subTabTable.totalData.value = res.data.list || [];
                    subTabTable.pageTotal.value = res.data.totalCount || 0;
                }
            }
        };
        const subTabTable = new BiddingAccountTableClass({
            Api: {
                listApi: getBiddingAccountList
            }
        });
        watch(
            () => [props.activeName, props.detailData],
            async (newVal, oldVal) => {
                if (newVal[0] === 'biddingAccount') {
                    newVal[1].customerCode && subTabTable.getList();
                } else {
                    subTabTable.totalData.value = [];
                    subTabTable.pageTotal.value = 0;
                }
            }
        );

        const state = reactive({
            searchHeaderParams: {}
        });

        const actionClick = (event, row) => { };

        const maskAccount = (account) => {
            if (!account || account.length <= 4) return account;
            return account.substring(0, 2) + '***' + account.substring(account.length - 2);
        };

        return {
            ...toRefs(state),
            config,
            TABLECONFIG,
            subTabTable,
            actionClick,
            maskAccount,
            desensitization: otherUtils.desensitization
        };
    }
};
</script>
<style lang='less'>
.contract-manage-iflow-table {
    .footer {
        padding: 10px 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .mip-page-link,
    .customer-mip-page-link {
        color: #4285f5;
        cursor: pointer;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }

        &.no-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .price-icon {
        font-size: 12px;
        cursor: pointer;
        color: #000;
    }

    .icon-active {
        color: #4285f5 !important;
    }
}
</style>
